import React, { memo, useEffect, useState } from 'react';
import { View, TouchableOpacity, StyleSheet, Modal } from 'react-native';
import { Text } from '../../../components/ui/AppText';
import { LinearGradient } from 'expo-linear-gradient';
import Animated, { SlideInUp, FadeIn } from 'react-native-reanimated';
import * as Haptics from 'expo-haptics';

const ChallengeLimitModal = memo(({
    visible,
    timeUntilReset,
    onClose,
}) => {
    const [countdown, setCountdown] = useState(timeUntilReset);

    useEffect(() => {
        if (!visible) return;

        const interval = setInterval(() => {
            const now = new Date();
            const tomorrow = new Date(now);
            tomorrow.setDate(tomorrow.getDate() + 1);
            tomorrow.setHours(0, 0, 0, 0);
            const diff = tomorrow.getTime() - now.getTime();

            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            setCountdown({ hours, minutes, formatted: `${hours}h ${minutes}min` });
        }, 60000); // Update every minute

        return () => clearInterval(interval);
    }, [visible]);

    const handleClose = () => {
        Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
        onClose();
    };

    if (!visible) return null;

    return (
        <Modal visible={visible} transparent animationType="none" statusBarTranslucent>
            <Animated.View entering={FadeIn.duration(200)} style={styles.overlay}>
                <Animated.View entering={SlideInUp.springify()} style={styles.modal}>
                    <LinearGradient
                        colors={['rgba(45, 35, 75, 0.98)', 'rgba(26, 11, 46, 0.99)']}
                        style={StyleSheet.absoluteFill}
                    />

                    {/* Icon */}
                    <Text style={styles.icon}>😅</Text>

                    {/* Title */}
                    <Text style={styles.title}>Limite diário atingido!</Text>

                    {/* Description */}
                    <Text style={styles.description}>
                        Você já enviou 4 desafios hoje.{'\n'}
                        Volte amanhã para desafiar mais!
                    </Text>

                    {/* Timer */}
                    <View style={styles.timerContainer}>
                        <Text style={styles.timerIcon}>⏰</Text>
                        <Text style={styles.timerLabel}>Reseta em: </Text>
                        <Text style={styles.timerValue}>{countdown.formatted}</Text>
                    </View>

                    {/* Button */}
                    <TouchableOpacity
                        style={styles.button}
                        onPress={handleClose}
                        activeOpacity={0.8}
                    >
                        <Text style={styles.buttonText}>Entendi</Text>
                    </TouchableOpacity>
                </Animated.View>
            </Animated.View>
        </Modal>
    );
});

const styles = StyleSheet.create({
    overlay: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 24,
    },

    modal: {
        width: '100%',
        borderRadius: 24,
        padding: 28,
        alignItems: 'center',
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.1)',
        overflow: 'hidden',
    },

    icon: {
        fontSize: 64,
        marginBottom: 16,
    },

    title: {
        fontSize: 22,
        fontWeight: '700',
        color: '#FF9500',
        marginBottom: 12,
        textAlign: 'center',
    },

    description: {
        fontSize: 15,
        color: 'rgba(255, 255, 255, 0.7)',
        textAlign: 'center',
        lineHeight: 22,
        marginBottom: 20,
    },

    timerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 149, 0, 0.1)',
        paddingHorizontal: 16,
        paddingVertical: 10,
        borderRadius: 12,
        marginBottom: 24,
    },

    timerIcon: {
        fontSize: 16,
        marginRight: 8,
    },

    timerLabel: {
        fontSize: 14,
        color: 'rgba(255, 255, 255, 0.6)',
    },

    timerValue: {
        fontSize: 14,
        fontWeight: '700',
        color: '#FF9500',
    },

    button: {
        width: '100%',
        paddingVertical: 14,
        borderRadius: 12,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        alignItems: 'center',
    },

    buttonText: {
        fontSize: 15,
        fontWeight: '600',
        color: '#FFFFFF',
    },
});

export default ChallengeLimitModal;
